import React from 'react';
import SolutionPublishEstimatePaymentContainer from 'containers/SolutionPublishEstimatePaymentContainer/SolutionPublishEstimatePaymentContainer';

export default function SolutionPublishEstimatePaymentPage() {
    return (
        <SolutionPublishEstimatePaymentContainer />
    )
}
